export const pipelineData = [
  {
    step_no: 1,
    formData: {
      formField: {
        path: 's3://dep-qa/inputs/Customer_1.csv',
        alias: 'customer_data',
        format: 'read_csv_aws',
        delimiter: ',',
        sample_view: true,
        dataTypeRead: 'refernce',
        pathTypeFile: 'filepath',
      },
      headerName: [
        { header: 'customer_id', checked: 'true' },
        { header: 'name', checked: 'true' },
        { header: 'country', checked: 'true' },
        { header: 'phone', checked: 'true' },
        { header: 'email', checked: 'true' },
      ],
    },
    currentNode: { nodeId: 'dndnode_1751979139496', nodeName: 'ReadCSV' },
    previousNodes: [],
  },
  {
    step_no: 2,
    formData: {
      formField: {
        path: 's3://dep-qa/inputs/support_tickets_updated.csv',
        alias: 'ticket_data',
        format: 'csv',
        delimiter: ',',
        sample_view: true,
        dataTypeRead: 'reference',
        pathTypeFile: 'filepath',
        connection_type: 'default',
      },
      headerName: [
        { header: 'ticket_id', checked: 'true' },
        { header: 'customer_id', checked: 'true' },
        { header: 'issue', checked: 'true' },
        { header: 'timestamp', checked: 'true' },
        { header: 'status', checked: 'true' },
      ],
    },
    currentNode: { nodeId: 'dndnode_1751979140520', nodeName: 'ReadCSVAws' },
    previousNodes: [],
  },
  {
    step_no: 3,
    formData: {
      count: { count_1: 1, count_2: 1 },
      onRow: [
        { row: 'row1', count: 'count_1', table1: 'customer_data.customer_id', table2: 'ticket_data.customer_id' },
      ],
      formField: {
        alias: 'joined_data',
        joins: { join1: 'inner' },
        tables: { table1: 'customer_data', table2: 'ticket_data' },
        select_cols: '',
        join_conditions: 'customer_data.customer_id = ticket_data.customer_id',
      },
      headerName: [
        { header: 'customer_data.customer_id', checked: 'false' },
        { header: 'customer_data.name', checked: 'true' },
        { header: 'customer_data.country', checked: 'true' },
        { header: 'customer_data.phone', checked: 'true' },
        { header: 'customer_data.email', checked: 'true' },
        { header: 'ticket_data.ticket_id', checked: 'true' },
        { header: 'ticket_data.issue', checked: 'true' },
        { header: 'ticket_data.timestamp', checked: 'true' },
        { header: 'ticket_data.status', checked: 'true' },
      ],
    },
    currentNode: { nodeId: 'dndnode_1751979141538', nodeName: 'Join' },
    previousNodes: [
      { nodeId: 'dndnode_1751979139496', nodeName: 'ReadCSV' },
      { nodeId: 'dndnode_1751979140520', nodeName: 'ReadCSVaws' },
    ],
  },
  {
    step_no: 4,
    formData: {
      sorting: [{ oper: '=', clause: 'AND', filter: 'India', header: 'country', condition: 'Condition_Group_1' }],
      addClause: [{ count: '1', clause: 'AND', condition: 'Condition_Group_1' }],
      formField: { df: 'joined_data', alias: 'filtered_data', statement: "country = 'India'" },
      attributes: ['Condition_Group_1'],
      headerName: [
        { header: 'customer_id', checked: 'true' },
        { header: 'name', checked: 'true' },
        { header: 'country', checked: 'true' },
        { header: 'phone', checked: 'true' },
        { header: 'email', checked: 'true' },
        { header: 'ticket_id', checked: 'true' },
        { header: 'issue', checked: 'true' },
        { header: 'timestamp', checked: 'true' },
        { header: 'status', checked: 'true' },
      ],
    },
    currentNode: { nodeId: 'dndnode_1751979143588', nodeName: 'Filter' },
    previousNodes: [{ nodeId: 'dndnode_1751979141538', nodeName: 'Join' }],
  },
  {
    step_no: 5,
    formData: {
      toggleType: 'S3',
      formField: {
        mode: 'overwrite',
        path: 'dep-qa/Internal/POC/Copilot Json Test/Output/WriteCsvAWS_1750668414647',
        alias: 'Customer_360',
        format: 'csv',
          df: 'filter_data',
      },
      headerName: [
        { header: 'customer_id', checked: 'true' },
        { header: 'name', checked: 'true' },
        { header: 'country', checked: 'true' },
        { header: 'phone', checked: 'true' },
        { header: 'email', checked: 'true' },
        { header: 'ticket_id', checked: 'true' },
        { header: 'issue', checked: 'true' },
        { header: 'timestamp', checked: 'true' },
        { header: 'status', checked: 'true' },
      ],
    },
    currentNode: { nodeId: 'dndnode_1751979142562', nodeName: 'WriteCsvAWS' },
    previousNodes: [{ nodeId: 'dndnode_1751979143588', nodeName: 'Filter' }],
  },
];
